const formatDate = (
  date: string | number | Date,
  options: Intl.DateTimeFormatOptions
) => {
  return new Date(date).toLocaleString("en-US", options);
};

export { formatDate };
